import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import * as request from 'request';

@Injectable()
export class ImagesService {
  constructor(private http: HttpClient) {}

  public uploadImageToImageBank(obj) {
    const body = {
      fileName: obj.fileName,
      imageBase64: obj.imageBase64,
      itemCategoryId: obj.itemCategoryId,
      itemKioskCategoryId: obj.itemKioskCategoryId,
      itemFeaturedItemId: obj.itemFeaturedItemId,
      itemImageItemId: obj.itemImageItemId,
      storeFeaturedImageStoreId: obj.storeFeaturedImageStoreId,
      storeId: obj.storeId,
      storeLogoStoreId: obj.storeLogoStoreId,
    };
    return this.http
      .post(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getAllStoreImages(id) {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;
    return this.http
      .get(environment.apiUrl + 'api/ext-image/by-store/' + id + paginationString + '&sort=id,desc')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addImageToFoodToGoCategory(categoryid, imageid) {
    const body = {
      id: imageid,
      foodToGoItemCategoryId: categoryid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addImageToCategory(categoryid, imageid) {
    const body = {
      id: imageid,
      itemCategoryId: categoryid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addImageToKioskCategory(kioskCategoryid, imageid) {
    const body = {
      id: imageid,
      itemCategoryKioskId: kioskCategoryid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addImageToCustomBuilder(builderFeaturedImageId, imageId) {
    const body = {
      id: imageId,
      builderFeaturedImageId: builderFeaturedImageId,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addImageToProduct(productid, imageid) {
    const body = {
      id: imageid,
      itemImageItemId: productid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addFeaturedImageToProduct(productid, imageid) {
    const body = {
      id: imageid,
      itemFeaturedItemId: productid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addLogoImageToStore(storeid, imageid) {
    const body = {
      id: imageid,
      storeLogoStoreId: storeid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public addFeaturedImageToStore(storeid, imageid) {
    const body = {
      id: imageid,
      storeFeaturedImageStoreId: storeid,
    };
    return this.http
      .put(environment.apiUrl + 'api/ext-image', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public removeImage(obj) {
    return this.http
      .put(environment.apiUrl + 'api/ext-image', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public deleteImage(image, storeid) {
    // console.log('delte service', image);
    const body = {
      //   fileName: image.name,
      //   imageBase64: image.name,
      imageId: image.id,
      storeId: storeid,
    };
    return this.http
      .post(environment.apiUrl + 'api/ext-image/delete', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  removeImageLink(obj) {
    return this.http
      .post(environment.apiUrl + 'api/ext-image/unlink', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/images.service.ts